export default __webpack_public_path__ + "static/media/portfolio-2.64b08747.jpg";